import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ProductOption, ScreenType } from '@app/shared/enums/enums';
import { ShowInterestComponent } from '../show-interest/show-interest.component';

@Component({
  selector: 'app-carousel',
  standalone: true,
  imports: [],
  templateUrl: './carousel.component.html',
  styleUrl: './carousel.component.scss',
})
export class CarouselComponent implements OnInit, OnDestroy {
  @Input() screenType: ScreenType = ScreenType.DESKTOP;

  currentIndex: number = 0;

  slides: { [key: string]: string | null }[] = [];

  private intervalId: any;

  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {
    this.slides = [
      // {
      //   image: `assets/product-banners/${this.screenType}/company-banner.png`,
      //   product: null,
      // },
      {
        image: `assets/product-banners/${this.screenType}/customer-portal-banner.png`,
        product: ProductOption.CUSTOMER_PORTAL,
      },
      {
        image: `assets/product-banners/${this.screenType}/ekoblend-banner.png`,
        product: ProductOption.EKO_BLEND,
      },
      {
        image: `assets/product-banners/${this.screenType}/ekobar-banner.png`,
        product: ProductOption.EKO_BAR,
      },
      {
        image: `assets/product-banners/${this.screenType}/tarshakti-banner.png`,
        product: ProductOption.TAR_SHAKIT,
      },
    ];

    this.startAutoPlay();
  }

  nextSlide() {
    if (this.currentIndex < this.slides.length - 1) {
      this.currentIndex++;
    }
  }

  previousSlide() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    }
  }

  startAutoPlay() {
    this.intervalId = setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    }, 3000);
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  openDialog(slideIndex: number) {
    if (this.slides[slideIndex]['product'] == ProductOption.CUSTOMER_PORTAL) {
      window.open('/login', '_blank');
      return;
    }

    this.dialog.open(ShowInterestComponent, {
      data: {
        product: this.slides[slideIndex]['product'],
      },
    });
  }
}
